import { render, staticRenderFns } from "./Tech.vue?vue&type=template&id=807da110&scoped=true&"
import script from "./Tech.vue?vue&type=script&lang=js&"
export * from "./Tech.vue?vue&type=script&lang=js&"
import style0 from "./Tech.vue?vue&type=style&index=0&id=807da110&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807da110",
  null
  
)

export default component.exports